/**
 * Persist Zelle orders list filters when navigating to order edit and back (Orders → Zelle view).
 */

export const ZELLE_ORDERS_FILTER_KEY = 'icct.zelleOrders.filters.v1';

const SNAP_VERSION = 1;

export function buildZelleOrdersSnapshot(filters) {
  return {
    v: SNAP_VERSION,
    source: filters.source ?? '',
    statusFilter: filters.statusFilter ?? '',
    searchText: filters.searchText ?? '',
    memoSearch: filters.memoSearch ?? '',
    orderIdSearch: filters.orderIdSearch ?? '',
    dateFromFilter: filters.dateFromFilter ?? '',
    dateToFilter: filters.dateToFilter ?? '',
    page: typeof filters.page === 'number' ? filters.page : 0,
  };
}

export function readZelleOrdersSnapshotFromSession() {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(ZELLE_ORDERS_FILTER_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (!o || o.v !== SNAP_VERSION) return null;
    return o;
  } catch {
    return null;
  }
}

export function saveZelleOrdersSnapshotToSession(snapshot) {
  try {
    sessionStorage.setItem(ZELLE_ORDERS_FILTER_KEY, JSON.stringify(snapshot));
  } catch {
    /* ignore */
  }
}

export function clearZelleOrdersSnapshotFromSession() {
  try {
    sessionStorage.removeItem(ZELLE_ORDERS_FILTER_KEY);
  } catch {
    /* ignore */
  }
}

/** One object for initializing ZellePaymentsPage state (runs once per mount). */
export function readZelleInitialFilterState() {
  const snap = readZelleOrdersSnapshotFromSession();
  if (!snap) {
    return {
      source: '',
      statusFilter: 'completed',
      searchText: '',
      memoSearch: '',
      orderIdSearch: '',
      dateFromFilter: '',
      dateToFilter: '',
      page: 0,
    };
  }
  const memo = String(snap.memoSearch ?? snap.searchText ?? '').trim();
  return {
    source: snap.source ?? '',
    statusFilter: snap.statusFilter !== undefined && snap.statusFilter !== '' ? snap.statusFilter : 'completed',
    searchText: snap.searchText ?? '',
    memoSearch: memo,
    orderIdSearch: snap.orderIdSearch ?? '',
    dateFromFilter: snap.dateFromFilter ?? '',
    dateToFilter: snap.dateToFilter ?? '',
    page: typeof snap.page === 'number' && snap.page >= 0 ? snap.page : 0,
  };
}
